import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_CATEGORY_ORGANIZATION,
  CREATE_CATEGORY_ORGANIZATION,
  DELETE_CATEGORY_ORGANIZATION,
  UPDATE_CATEGORY_ORGANIZATION,
} from "./actionType";

import {
  CategoryOrganizationApiResponseSuccess,
  CategoryOrganizationApiResponseError,
} from "./action";

import {
  getCategoryOrganization as getOrganizationCategory,
  createCategoryOrganization as createOrganizationCategory,
  updateCategoryOrganization as updateOrganizationCategory,
  deleteCategoryOrganization as deleteOrganizationCategory,
} from "../../helpers/backend_helper";
import { notifyError, notifySuccess } from "../../components/notify";

function* getCategoryOrganization() {
  try {
    const response = yield call(getOrganizationCategory);
    yield put(
      CategoryOrganizationApiResponseSuccess(
        GET_CATEGORY_ORGANIZATION,
        response
      )
    ); 
  } catch (error) {
    yield put(
      CategoryOrganizationApiResponseError(GET_CATEGORY_ORGANIZATION, error)
    );
  }
}

function* createCategoryOrganization(data) {
  try {
    const response = yield call(createOrganizationCategory, data.payload.data);
    yield put(
      CategoryOrganizationApiResponseSuccess(
        CREATE_CATEGORY_ORGANIZATION,
        response
      )
    ); notifySuccess("Categoria criada com sucesso!");
  } catch (error) {
    yield put(
      CategoryOrganizationApiResponseError(CREATE_CATEGORY_ORGANIZATION, error)
      ); 
      notifyError("Erro ao criar credencial!");
  } 
}

function* updateCategoryOrganization(data) {
  try {
    const response = yield call(updateOrganizationCategory, data.payload.data);
    yield put(
      CategoryOrganizationApiResponseSuccess(
        UPDATE_CATEGORY_ORGANIZATION,
        response
      )
    ); notifySuccess("Categoria atualizada com sucesso!");
  } catch (error) {
    yield put(
      CategoryOrganizationApiResponseError(UPDATE_CATEGORY_ORGANIZATION, error)
    );
    notifyError("Erro ao atualizar credencial!");
  }
}

function* deleteCategoryOrganization(data) {
  try {
    const response = yield call(deleteOrganizationCategory, data.payload.id);
    yield put(
      CategoryOrganizationApiResponseSuccess(
        DELETE_CATEGORY_ORGANIZATION,
        response
      )
    ); 
    notifySuccess("Categoria deletada com sucesso!");
  } catch (error) {
    yield put(
      CategoryOrganizationApiResponseError(DELETE_CATEGORY_ORGANIZATION, error)
    ); 
    notifyError("Erro ao deletar credencial!");

  }
}

export function* watchGetCategoryOrganization() {
  yield takeEvery(GET_CATEGORY_ORGANIZATION, getCategoryOrganization);
}

export function* watchCreateCategoryOrganization() {
  yield takeEvery(CREATE_CATEGORY_ORGANIZATION, createCategoryOrganization);
}

export function* watchUpdateCategoryOrganization() {
  yield takeEvery(UPDATE_CATEGORY_ORGANIZATION, updateCategoryOrganization);
}

export function* watchDeleteCategoryOrganization() {
  yield takeEvery(DELETE_CATEGORY_ORGANIZATION, deleteCategoryOrganization);
}

function* CategoryOrganizationSaga() {
  yield all([fork(watchGetCategoryOrganization)]);
  yield all([fork(watchCreateCategoryOrganization)]);
  yield all([fork(watchUpdateCategoryOrganization)]);
  yield all([fork(watchDeleteCategoryOrganization)]);
}

export default CategoryOrganizationSaga;
